export default __webpack_public_path__ + "static/media/243.bd56f706.jpg";